<template>
  <div>
    <span v-if="headerProps.column.label === 'Invoice amount'" @click="$emit('onUserSortClicked')">
          <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.invoiceAmountToolTip"> {{headerProps.column.label}} </header-with-tooltip>
    </span>
    <span v-else-if="headerProps.column.label === 'Invoice date'" @click="$emit('onUserSortClicked')">
          <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.dateTooltip"> {{headerProps.column.label}} </header-with-tooltip>
    </span>
    <span v-else-if="headerProps.column.label === 'Payment due date'" @click="$emit('onUserSortClicked')">
          <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.dateTooltip"> {{headerProps.column.label}} </header-with-tooltip>
    </span>
    <span v-else-if="headerProps.column.label === 'Payment date'" @click="$emit('onUserSortClicked')">
          <header-with-tooltip :tooltipText="FORM_LABELS.TOOLTIPS.dateTooltip"> {{headerProps.column.label}} </header-with-tooltip>
    </span>
    <span v-else @click="$emit('onUserSortClicked')">{{headerProps.column.label}}</span>
  </div>
</template>

<script>
import FORM_LABELS from "@/store/FormLabels";
import HeaderWithTooltip from "@/components/HeaderWithTooltip";

export default {
  name: "InvoicesTableHeader",
  props: ["headerProps"],
  components: {HeaderWithTooltip},
  data() {
    return {
      FORM_LABELS: FORM_LABELS
    }
  }
}
</script>

<style scoped>

</style>